import * as types from './scheduleViewerActionType';

export const fetchShiftsRequest = (filters) => ({ type: types.FETCH_SHIFTS_REQUEST, payload: filters });
export const fetchShiftsSuccess = (data) => ({ type: types.FETCH_SHIFTS_SUCCESS, payload: data });
export const fetchShiftsFailure = (error) => ({ type: types.FETCH_SHIFTS_FAILURE, payload: error });

export const setScheduleView = (view) => ({ type: types.SET_SCHEDULE_VIEW, payload: view });
export const setScheduleFilters = (filters) => ({ type: types.SET_SCHEDULE_FILTERS, payload: filters });
export const setSelectedShift = (shift) => ({ type: types.SET_SELECTED_SHIFT, payload: shift });
export const clearSelectedShift = () => ({ type: types.CLEAR_SELECTED_SHIFT });

export const fetchScheduleDropdownsRequest = () => ({ type: types.FETCH_SCHEDULE_DROPDOWNS_REQUEST });
export const fetchScheduleDropdownsSuccess = (data) => ({ type: types.FETCH_SCHEDULE_DROPDOWNS_SUCCESS, payload: data });
export const fetchScheduleDropdownsFailure = (error) => ({ type: types.FETCH_SCHEDULE_DROPDOWNS_FAILURE, payload: error });

export const saveShiftRequest = (payload) => ({ type: types.SAVE_SHIFT_REQUEST, payload });
export const saveShiftSuccess = () => ({ type: types.SAVE_SHIFT_SUCCESS });
export const saveShiftFailure = (error) => ({ type: types.SAVE_SHIFT_FAILURE, payload: error });

export const saveShiftBulkRequest = (payload) => ({ type: types.SAVE_SHIFT_BULK_REQUEST, payload });
export const saveShiftBulkSuccess = (result) => ({ type: types.SAVE_SHIFT_BULK_SUCCESS, payload: result });
export const saveShiftBulkFailure = (error) => ({ type: types.SAVE_SHIFT_BULK_FAILURE, payload: error });
export const clearBulkResult = () => ({ type: types.CLEAR_BULK_RESULT });

export const deleteShiftRequest = (shiftId) => ({ type: types.DELETE_SHIFT_REQUEST, payload: shiftId });
export const deleteShiftSuccess = () => ({ type: types.DELETE_SHIFT_SUCCESS });
export const deleteShiftFailure = (error) => ({ type: types.DELETE_SHIFT_FAILURE, payload: error });

export const updateShiftGroupRequest = (payload) => ({ type: types.UPDATE_SHIFT_GROUP_REQUEST, payload });
export const updateShiftGroupSuccess = () => ({ type: types.UPDATE_SHIFT_GROUP_SUCCESS });
export const updateShiftGroupFailure = (error) => ({ type: types.UPDATE_SHIFT_GROUP_FAILURE, payload: error });

export const swapShiftRequest = (payload) => ({ type: types.SWAP_SHIFT_REQUEST, payload });
export const swapShiftSuccess = (result) => ({ type: types.SWAP_SHIFT_SUCCESS, payload: result });
export const swapShiftFailure = (error) => ({ type: types.SWAP_SHIFT_FAILURE, payload: error });

export const swapShiftGroupRequest = (payload) => ({ type: types.SWAP_SHIFT_GROUP_REQUEST, payload });
export const swapShiftGroupSuccess = (result) => ({ type: types.SWAP_SHIFT_GROUP_SUCCESS, payload: result });
export const swapShiftGroupFailure = (error) => ({ type: types.SWAP_SHIFT_GROUP_FAILURE, payload: error });

export const deleteShiftGroupRequest = (payload) => ({ type: types.DELETE_SHIFT_GROUP_REQUEST, payload });
export const deleteShiftGroupSuccess = () => ({ type: types.DELETE_SHIFT_GROUP_SUCCESS });
export const deleteShiftGroupFailure = (error) => ({ type: types.DELETE_SHIFT_GROUP_FAILURE, payload: error });

export const setConflictPreview = (payload) => ({ type: types.SET_CONFLICT_PREVIEW, payload });
export const clearConflictPreview = () => ({ type: types.CLEAR_CONFLICT_PREVIEW });

export const updateShiftNotesRequest = (shiftId, notes) => ({
    type: types.UPDATE_SHIFT_NOTES_REQUEST,
    payload: { shiftId, notes },
});
export const updateShiftNotesSuccess = () => ({ type: types.UPDATE_SHIFT_NOTES_SUCCESS });
export const updateShiftNotesFailure = (error) => ({ type: types.UPDATE_SHIFT_NOTES_FAILURE, payload: error });

export const fetchShiftPrivilegesRequest = (radiologistId, asOfDate) => ({
    type: types.FETCH_SHIFT_PRIVILEGES_REQUEST,
    payload: { radiologistId, asOfDate },
});
export const fetchShiftPrivilegesSuccess = (data) => ({ type: types.FETCH_SHIFT_PRIVILEGES_SUCCESS, payload: data });
export const fetchShiftPrivilegesFailure = (error) => ({ type: types.FETCH_SHIFT_PRIVILEGES_FAILURE, payload: error });

export const fetchRadAssociatedSitesRequest = (radiologistId, asOfDate) => ({
    type: types.FETCH_RAD_ASSOCIATED_SITES_REQUEST,
    payload: { radiologistId, asOfDate },
});
export const fetchRadAssociatedSitesSuccess = (data) => ({
    type: types.FETCH_RAD_ASSOCIATED_SITES_SUCCESS,
    payload: data,
});
export const fetchRadAssociatedSitesFailure = (error) => ({
    type: types.FETCH_RAD_ASSOCIATED_SITES_FAILURE,
    payload: error,
});
export const clearRadAssociatedSites = () => ({ type: types.CLEAR_RAD_ASSOCIATED_SITES });

export const fetchRadsAssociatedSitesRequest = (radiologistIds, asOfDate) => ({
    type: types.FETCH_RADS_ASSOCIATED_SITES_REQUEST,
    payload: { radiologistIds, asOfDate },
});
export const fetchRadsAssociatedSitesSuccess = (sitesByRad) => ({
    type: types.FETCH_RADS_ASSOCIATED_SITES_SUCCESS,
    payload: sitesByRad,
});
export const fetchRadsAssociatedSitesFailure = (error) => ({
    type: types.FETCH_RADS_ASSOCIATED_SITES_FAILURE,
    payload: error,
});
